import { store } from 'Stores/index'

import { PortalSectionEnum } from 'Constants/portalSection'

import { SearchResultsPage } from '../pages/SearchResults/SearchResults.page'
import { SearchResultsRoutePathsEnum } from './searchResultsRouteConfig.types'

export const SEARCH_RESULTS_ROUTES = [
  {
    component: SearchResultsPage,
    onRender: () => {
      const { portalSettingsStore } = store
      const { setCurrentPortalSection } = portalSettingsStore

      setCurrentPortalSection(PortalSectionEnum.SearchResults)
    },
    path: SearchResultsRoutePathsEnum.SEARCH_RESULTS,
  },
]
